import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";

import { ProgressBar } from "react-bootstrap";
// import { Checkbox } from '@mui/material';
import Sound from 'react-sound';
import { base, s3base } from "api.js";
import "components/custom.css";
import ReactHtmlParser from 'react-html-parser';
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

const Highlight = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [answerData, setAnswerData] = useState([]);
  const [soundPer, setSoundPer] = useState(0);
  const [answerFlag, setAnswerFlag] = useState(true);
  const [volume, setVolume] = useState(90);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const [audioFinished, setAudioFinished] = useState(false);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);
  const answerFlagRef = useRef(answerFlag);
  const correctFlagRef = useRef(correctFlag);
  const hasCalledUpdateCorrect = useRef(false);
  const hasCalledAnswerGenerated = useRef(false);

  const { data, testMode, resultMode } = props;

  useEffect(() => {
    answerFlagRef.current = answerFlag;
  }, [answerFlag]);

  useEffect(() => {
    correctFlagRef.current = correctFlag;
  }, [correctFlag]);

  const timer = useCallback(() => {
    setSecondCount(prevCount => {
      if (prevCount === 1) {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
      }
      return prevCount - 1;
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(timer, 1000);
    intervalIdRef.current = interval;

    if (props.data && props.data.media_link) {
      props.updateQuestionAudioUrlInPractice(`${s3base}${props.data.media_link}`);
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, []);

  // const stopTest = () => {
  //   props.nextQuestion(resultObj);
  // };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    setAudioFinished(true);
    props.soundChecked();
    props.showResult();
    if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  // const timerRecord = () => {
  //   setRecordCount(prevCount => {
  //     if (prevCount === 40) {
  //       if (recordIdRef.current) {
  //         clearInterval(recordIdRef.current);
  //       }
  //       // Note: stop() function is not defined in original code
  //     }
  //     return prevCount + 1;
  //   });
  // };

  // const handleChange = (event) => {
  //   setSelectedValue(event.target.value);
  // };

  const selectSpan = (e) => {
    let arr = [...answerData];
    if (e.target.className === "highlight1") {
      e.target.classList.remove("highlight1");
      arr = arr.filter(function (val) {
        return val !== e.target.innerHTML;
      });
    } else {
      e.target.classList.add("highlight1");
      arr.push(e.target.innerHTML);
    }

    // const correctAnswer = props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 === 0) { return i; } }).map(function (x) { return x.split(' ')[x.split(' ').length - 1] });

    // const correctAnswer = Array.from(
    //   props.data.answer.matchAll(
    //     /(\b[\w'-]+)\s*<span[^>]*id=['"]cAns['"][^>]*>.*?<\/span>/g
    //   ),
    //   match => match[1]
    // );
    const temp = document.createElement("div");
    temp.innerHTML = props.data.answer;

    const correctAnswer = Array.from(temp.querySelectorAll("span#cAns")).map(span => {
      const text = span.previousSibling?.textContent || "";
      return text.trim().split(/\s+/).pop();
    });
    const html = document.querySelector('.highlight_question').innerHTML;

    props.submit({
      answer: arr,
      correct: correctAnswer,
      html: html
    }, true);

    setAnswerData(arr);
    setResultObj({
      answer: arr,
      correct: correctAnswer,
      html: html
    });
  };

  const answergenerated = useCallback(() => {
    if (answerFlagRef.current && document.querySelectorAll('.highlight_question .correct').length > 0) {
      setAnswerFlag(false);
      let elem = document.querySelectorAll('.highlight_question span');
      for (var i = 0; i < elem.length; i++) {
        let hig = document.querySelectorAll('.highlight_question span')[i].classList.value;
        let higText = document.querySelectorAll('.highlight_question span')[i].textContent;
        if (hig == "correct hidd") {
          document.querySelectorAll('.highlight_question span')[i - 1].classList.add('empty-highlight-result');
        }
      }
      for (var i = 0; i < elem.length; i++) {
        let hig = document.querySelectorAll('.highlight_question span')[i].classList.value;
        let higText = document.querySelectorAll('.highlight_question span')[i].textContent;
        let corr = "";
        if (elem.length > (i + 1)) {
          corr = document.querySelectorAll('.highlight_question span')[i + 1].classList.value;
        }
        if (hig.match("highlight1")) {
          if (corr == "correct hidd") {
            document.querySelectorAll('.highlight_question span')[i].classList.remove('empty-highlight-result');
            document.querySelectorAll('.highlight_question span')[i].classList.add('correct-highlight-result');
          } else {
            document.querySelectorAll('.highlight_question span')[i].classList.remove('empty-highlight-result');
            document.querySelectorAll('.highlight_question span')[i].classList.add('wrong-highlight-result');
          }
        }
      }
    }
  }, []);

  const updateCorrect = useCallback(() => {
    if (props.data && !hasCalledUpdateCorrect.current) {
      // const correctAnswer = props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function (i, x) { if (x % 2 === 0) { return i; } }).map(function (x) { return x.split(' ')[x.split(' ').length - 1] });
      // const correctAnswer = Array.from(
      //   props.data.answer.matchAll(
      //     /(\b[\w'-]+)\s*<span[^>]*id=['"]cAns['"][^>]*>.*?<\/span>/g
      //   ),
      //   match => match[1]
      // );
      const temp = document.createElement("div");
      temp.innerHTML = props.data.answer;

      const correctAnswer = Array.from(temp.querySelectorAll("span#cAns")).map(span => {
        const text = span.previousSibling?.textContent || "";
        return text.trim().split(/\s+/).pop();
      });

      props.submit({ 'answer': [], 'correct': correctAnswer, html: '' });
      setCorrectFlag(false);
      setResultObj({ 'answer': [], 'correct': correctAnswer, html: '' });
      hasCalledUpdateCorrect.current = true;
    }
  }, [props.data?.id]);

  const skip = () => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }
    setSecondCount(0);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevKey => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  const selectAndTryAudio = useCallback((index) => {
    const { question_audios } = props.data;
    if (question_audios && question_audios.length > 0 && index < question_audios.length) {
      const selected = question_audios[index];
      setQuestionAudio(`${s3base}/${selected.value}`);
      setDefaultSelectedVoice(selected.label);
      setCurrentAudioIndex(index);
    }
  }, [props.data]);

  const handleAudioError = useCallback((errorCode, description) => {
    console.log("Got the error", errorCode, description);
    const { question_audios, media_link } = props.data;
    
    if (!question_audios || question_audios.length === 0) {
      console.error("No alternative audio available, using media_link");
      setQuestionAudio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      return;
    }

    if (audioRetryCount >= question_audios.length) {
      console.error("All audios failed, falling back to media_link");
      setQuestionAudio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      setAudioRetryCount(0);
      return;
    }

    const nextIndex = (currentAudioIndex + 1) % question_audios.length;
    setAudioRetryCount(prevCount => prevCount + 1);
    setSoundKey(prevKey => prevKey + 1);
    
    setTimeout(() => {
      // selectAndTryAudio(nextIndex);
    }, 100);
  }, [props.data, currentAudioIndex, audioRetryCount, selectAndTryAudio]);

  const getQuestionAudio = useCallback((data) => {
    if (!data) {
      return { question_audio_local: null, defaultSelectedVoice_local: null };
    }

    let question_audio_local = null;
    let defaultSelectedVoice_local = null;

    // Multiple voices available → random selection
    if (data.question_audios && data.question_audios.length > 0) {
      const x = Math.floor(
        Math.random() * Math.min(6, data.question_audios.length)
      );
      const selected = data.question_audios[x];
      question_audio_local = `${s3base}/${selected.value}`;
      defaultSelectedVoice_local = selected.label;
      setCurrentAudioIndex(x);
      setAudioRetryCount(0);
    }
    // Fallback to old single audio
    else if (data.media_link) {
      question_audio_local = `${s3base}${data.media_link}`;
    }

    return { question_audio_local, defaultSelectedVoice_local };
  }, []);

  const changeAudio = useCallback(
    (selected) => {
      if (audioFinished || props.answer) return;
      if (!props.data?.question_audios) return;

      const selectedAudio = props.data.question_audios.find(
        (audio) => audio.label === selected.label
      );
      if (!selectedAudio) return;

      const newAudioUrl = `${s3base}/${selectedAudio.value}`;

      // Reset audio states without affecting timer
      setQuestionAudio(newAudioUrl);
      setDefaultSelectedVoice(selected.label);
      setSoundKey((prev) => prev + 1);
      setSoundPer(0);
    },
    [props.data?.question_audios, audioFinished, props.answer]
  );

  const playingQuestionSectionLabel = () => {
    let status = '';
      if (props.answer) {
    return 'Question audio finished.';
  }
    if (!isRecording) {
      if (secondCount !== 0 && soundStatus === true) {
        status = `Beginning in ${secondCount} seconds`;
      } else if (secondCount === 0 && soundStatus) {
        status = 'Playing question audio...';
      } else {
        status = 'Question audio finished.';
      }
    } else {
      status = 'Question audio finished.';
    }
    return status;
  };

    useEffect(() => {
    if (!props.data) return;

    const currentId = props.data.id;

    // New question or restart
    if (!questionId || questionId !== currentId || props.restart) {
      // Clean up intervals
      if (intervalIdRef.current) clearInterval(intervalIdRef.current);
      if (recordIdRef.current) clearInterval(recordIdRef.current);

      const { question_audio_local, defaultSelectedVoice_local } =
        getQuestionAudio(props.data);

      setQuestionAudio(question_audio_local);
      setDefaultSelectedVoice(defaultSelectedVoice_local);
      setQuestionId(currentId);
      setCorrectFlag(true);
      setRecordCount(0);
      setSoundPer(0);
      setSecondCount(10);
      setSoundStatus(true);
      setAudioFinished(false);
      setSoundKey((prev) => prev + 1);

      // Notify parent about current audio (if needed)
      if (question_audio_local && props.updateQuestionAudioUrlInPractice) {
        props.updateQuestionAudioUrlInPractice(question_audio_local);
      }

      // Reset UI elements
      var els = document.querySelectorAll('.highlight_question span');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove('wrong-anss');
        els[i].classList.remove('correct-anss');
        els[i].classList.remove('blue-bg');
        els[i].classList.remove('highlight1');
      }

      setAnswerData([]);
      setIsRecording(false);
      setBlobURL('');
      setReset(true);
      setAnswerFlag(true);
      hasCalledUpdateCorrect.current = false;
      hasCalledAnswerGenerated.current = false;

      // Start countdown again
      setReset(true);
    }
  }, [props.data?.id, props.restart, getQuestionAudio]);

  const showSkipAudioWaitButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount !== 0 && blobURL === '' && !isRecording) {
      button = true;
    }

    return button;
  };
  
  const showSkipAudioButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount === 0 && soundStatus === true && !isRecording) {
      button = true;
    }

    return button;
  };

    const stopAudio = () => {
    setSoundStatus(false);
     if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const playAudio = () => {
    const { data, resultMode } = props;

    let audio = false;
    if (data && !resultMode && soundStatus && secondCount === 0) {
      audio = true;
    }

    return audio;
  };

  const filterContent = (answer) => {
    return answer.replace(/<span[^>]*>?/g, ' __')
      .replace(/<[^>]*span>?/g, '__')
      .split(' ');
  };

  useEffect(() => {
    if (reset) {
      const interval = setInterval(timer, 1000);
      intervalIdRef.current = interval;
      setReset(false);
      document.querySelectorAll("span.highlight").forEach(function (job) {
        job.classList.remove('highlight');
      });
    }
  }, [reset, timer]);

  // Handle restart
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  // Handle answer generation
  useEffect(() => {
    if (props.answer && !hasCalledAnswerGenerated.current) {
      answergenerated();
      hasCalledAnswerGenerated.current = true;
    }
  }, [props.answer, answergenerated]);

  // Reset answer generated flag when question changes
  useEffect(() => {
    hasCalledAnswerGenerated.current = false;
  }, [props.data?.id]);

  // // Handle stop recording
  // useEffect(() => {
  //   if (props.stopRecording) {
  //     stopTest();
  //   }
  // }, [props.stopRecording]);

  // Handle updateCorrect
  useEffect(() => {
    if (props.data && correctFlagRef.current && !hasCalledUpdateCorrect.current) {
      updateCorrect();
    }
  }, [props.data?.id, updateCorrect]);

  // let question = "";
  // let answer = "";
  // let correct = "";

  // if (props.data) {
  //   question = props.data.question;
  //   answer = props.data.answer;
  //   correct = answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => { if (k % 2 == 1) { return v.trim(); } });
  // }

  // Replace the problematic code with these useMemo hooks:
const question = useMemo(() => {
  return props.data?.question || "";
}, [props.data?.question]);

const answer = useMemo(() => {
  return props.data?.answer || "";
}, [props.data?.answer]);

const correct = useMemo(() => {
  if (!answer) return [];
  return answer
    .replace(/<[^>]*>?/gm, 'x_x')
    .split('x_x')
    .filter((v, k) => k % 2 === 1)
    .map(v => v.trim());
}, [answer]);

  return (
    <>
    {/*  || `${s3base}${data.media_link}` */}
      {playAudio() &&
        <Sound
          url={questionAudio}
          playStatus={props.answer || !props.soundStatusMain ? Sound.status.STOPPED : Sound.status.PLAYING}
          onFinishedPlaying={handleSongFinishedPlaying}
          onPlaying={handleSongPlaying}
          onError={handleAudioError}
          volume={volume}
          playbackRate={playbackSpeed}
          key={soundKey}
        />
      }

      <div className="pmw-tabs-section d-flex align-items-start justify-content-center pmw-outer-wrapper recorded-wrapper challenge-content-wrapper mx-0">
        {/* <div className="recorded-section h-100 width-25" width-50></div> visibility-visible */}
        <div className="recorded-section h-100 p-0 m-0">
          <div className="recorded-content">
            <div className="row">
              <div className="col-12">
                <ul className="recorded-list">
                  <li>Status:</li>
                  <li>{playingQuestionSectionLabel()}</li>
                </ul>
              </div>

                {/* <div className="col-4"> <span className="volume-label">Volume</span> </div> */}
            </div>

            <div className="recorded-audio-wrapper">
              <div className="mt-3 clearfix">

                <div className="row">
                  <div className="col-10 col-sm-11">
                    <ProgressBar now={(soundPer)} striped />
                  </div>
                  <div className="col-1">
                    <div className="volume-control-wrapper">
                      <span className="volume-icon">
                        <i className="fa fa-volume-up" aria-hidden="true"></i>
                      </span>
                      <div className="re-volume-wrapper-horizontal">
                        <input
                          type="range"
                          placeholder="Volume"
                          className="volume-control"
                          min="0"
                          max="100"
                          step="1"
                          defaultValue={volume}
                          onInput={changeRange}
                          style={{
                            "--progress": `${(volume / 100) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mt-2">
                    {/* visibility-visible */}
                    <div className="pull-left">
                      <PlaybackSpeedBtns
                       answer={props.answer}
                        sound = {soundStatus}
                        changePlaybackSpeed={changePlaybackSpeed}
                        playbackSpeed={playbackSpeed}
                      />
                    </div>
                    {defaultSelectedVoice !== null &&
                      <div className="mx-2 pull-left visibility-visible">
                        <SelectVoiceDropDown
                        answer={props.answer}
                        sound={soundStatus}
                        voices={props.data?.question_audios || []}
                        selected={defaultSelectedVoice}
                        changeAudio={changeAudio}
                        />
                      </div>
                    }

                    {showSkipAudioWaitButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={skip}
                        >Start Audio</a>
                      </div>
                    }

                     {showSkipAudioButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={stopAudio}
                        >Stop Audio</a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
          {/* visibility-visible */}
      <div className="radiolist-content custom-box mx-0">
        {!testMode &&
          <div className="highlight_question" style={{ lineHeight: "2.2rem" }}>
            {data && !resultMode && filterContent(answer).map(function (item, i) {
              if (item.match(/__.*__/g)) {
                return <React.Fragment key={i}>{props.answer && <span className="correct hidd">{item.replace(/__/g, '')}</span>}</React.Fragment>;
              } else {
                return <React.Fragment key={i}><span onClick={selectSpan} className="">{item}</span>&nbsp; </React.Fragment>;
              }
            })}
          </div>
        }
      </div>
    </>
  );
};

export default Highlight;
